export const GET_DASHBOARD_FINISH_TASKS = 'GET_DASHBOARD_FINISH_TASKS';
export const GET_DASHBOARD_FINISH_TASKS_SUCCESS = 'GET_DASHBOARD_FINISH_TASKS_SUCCESS';
export const GET_DASHBOARD_FINISH_TASKS_ERROR = 'GET_DASHBOARD_FINISH_TASKS_ERROR';
